import api from './api';

export interface Coupon {
  id: number;
  code: string;
  description?: string | null;
  discount_type: 'percent' | 'value' | 'tokens';
  discount_value: number;
  max_redemptions: number;
  redeemed_count: number;
  active: boolean;
  expires_at?: string | null;
}

export interface CouponCreatePayload {
  code: string;
  description?: string;
  discount_type: 'percent' | 'value' | 'tokens';
  discount_value: number;
  max_redemptions?: number;
  expires_at?: string | null;
}

export const couponsService = {
  async list(): Promise<Coupon[]> {
    const r = await api.get('/admin/coupons/');
    return r.data.items || [];
  },

  async create(payload: CouponCreatePayload): Promise<Coupon> {
    const r = await api.post('/admin/coupons/', payload);
    return r.data.coupon;
  },

  async deactivate(id: number): Promise<void> {
    await api.post(`/admin/coupons/${id}/deactivate`);
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/admin/coupons/${id}`);
  },
};

export default couponsService;
